import React from 'react';

const Header = () => {
  return(
      <nav id="navbar">
        <a className="navbar-brand" href="/">Vintage Radios <br />Shop</a>
        <a className="item" href="/">Latest builds</a>
        <a className="item" href="/">Customize your own Radio</a>
      </nav>
  );
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js